import { CsvTemplateOptions, getEnumTypeValue } from "../../Services/PracticeDataRequestService";

// Normalizes a raw data-conversion-file record (server or in-memory) into a consistent shape.
export const normalizeFile = (item: any) => {
  if (!item)
    return { name: "", type: undefined, file: null, rawFile: null };
  const rawType =
    item.type !== undefined
      ? item.type
      : item.Type !== undefined
        ? item.Type
        : item.importType;
  const enumType = getEnumTypeValue(rawType);
  const fileName =
    item.name ||
    item.Name ||
    item.file?.name ||
    item.File?.Name ||
    item.File?.name ||
    (item.rawFile as File)?.name ||
    "";

  const rawFileObj =
    item.file ||
    item.File ||
    (item.fileUrl || item.FileUrl
      ? { path: item.fileUrl || item.FileUrl, name: fileName }
      : null);

  const fileObj = rawFileObj
    ? {
        id: rawFileObj.id || rawFileObj.Id,
        name: rawFileObj.name || rawFileObj.Name || fileName,
        path: rawFileObj.path || rawFileObj.Path || "",
        contentType: rawFileObj.contentType || rawFileObj.ContentType,
        length: rawFileObj.length ?? rawFileObj.Length,
      }
    : null;

  const rawF =
    item.rawFile ||
    item.originFileObj ||
    (item.file instanceof File ? item.file : null);

  return {
    name: fileName,
    file: fileObj,
    type: enumType,
    subType:
      item?.SubType ??
      item?.subType ??
      item?.EmailTemplateSubType ??
      item?.emailTemplateSubType,
    emailTemplateSubType:
      item?.EmailTemplateSubType ??
      item?.emailTemplateSubType ??
      item?.SubType ??
      item?.subType,
    rawFile: rawF,
  };
};

// Orders data-conversion files by the canonical CSV template option order.
export const sortDataConversionFiles = (files: any[]) => {
  const optionsOrder = CsvTemplateOptions.map((opt) => opt.value);
  return [...(files || [])].map(normalizeFile).sort((a, b) => {
    const idxA = optionsOrder.indexOf(a.type as any);
    const idxB = optionsOrder.indexOf(b.type as any);
    return (idxA === -1 ? 999 : idxA) - (idxB === -1 ? 999 : idxB);
  });
};
